export enum BLOCKER_TYPES {
    ARCHIVE = 'ARCHIVE',
    SHARED_DRIVES = 'SHARED_DRIVES'
}

export const CLASS_ABSTRACT_DASHBOARD_SCROLL_PREVENT = 'abstract-dashboard-scroll-prevent';
